import React from 'react';

const Close = ({ color = 'F5F5F5' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <g fill={`${color}`}>
        <g>
          <g>
            <path
              d="M3.784 3.089l.07.057 8.131 8.132 8.132-8.132c.195-.195.512-.195.707 0 .174.174.193.443.058.638l-.058.07-8.132 8.131 8.132 8.132c.195.195.195.512 0 .707-.173.174-.443.193-.638.058l-.069-.058-8.132-8.132-8.131 8.132c-.196.195-.512.195-.708 0-.173-.173-.192-.443-.057-.638l.057-.069 8.132-8.132-8.132-8.131c-.195-.196-.195-.512 0-.708.174-.173.443-.192.638-.057z"
              transform="translate(-12 -108) translate(0 96) translate(12 12)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Close;
